// Canonical garment size order — mirrors CoverageReport::SIZE_ORDER
// (app/Services/Catalog/CoverageReport.php); keep the two in sync.
export const SIZE_ORDER = ["NB", "6M", "12M", "18M", "24M", "2", "3", "4", "5/6", "7", "XXS", "XS", "S", "M", "L", "XL", "2X", "3X", "4X", "5X", "6X", "OS"];

const RANK = new Map(SIZE_ORDER.map((size, i) => [size, i]));

// A size's index in SIZE_ORDER; sizes outside it (pin inches, phone-case
// styles, …) share the last rank.
export function sizeRank(size) {
  return RANK.get(String(size).toUpperCase()) ?? SIZE_ORDER.length;
}

// Sorts `items` by canonical size order. Unknown sizes go last and keep their
// incoming order (sort is stable).
export function sortBySize(items, sizeOf) {
  return [...items].sort((a, b) => sizeRank(sizeOf(a)) - sizeRank(sizeOf(b)));
}
